import React, { useRef } from "react";
import useDeferredLoad from "../../rendering/useDeferredLoad";
import { useHomeLang } from "./homeLang";
import "./trustBanner.css";

// Served from public/logos rather than imported: CRA runs SVGR over imported
// .svg files, and several of these brand SVGs carry tags it rejects.
const LOGO_BASE = `${process.env.PUBLIC_URL}/logos`;

// The two dominant Italian advisor networks first, then the global names,
// then the advisors' register and professional body: only where financial
// advisors come from. `scale` sizes each logo so it puts about as much ink on the row as
// the others: drawn in the same box, a dense mark like Allianz's looks
// bigger than a light one like EFPA's. Measured once from the files: the
// square root of the row's mean ink over the logo's own, ink being the area
// it takes in its box times the share of that area it fills. `aspect` is the
// file's width over its height, so each logo's cell is only as wide as the
// logo and the row's gaps come out even.
export const LOGOS = [
  { file: "banca-mediolanum.svg", name: "Banca Mediolanum", scale: 0.99, aspect: 4.27 },
  { file: "fideuram.svg", name: "Fideuram", scale: 0.9, aspect: 4.13 },
  { file: "allianz.svg", name: "Allianz", scale: 0.84, aspect: 4.03 },
  { file: "schroders.svg", name: "Schroders", scale: 0.97, aspect: 5.59 },
  { file: "ocf.png", name: "OCF – Organismo Consulenti Finanziari", scale: 1.29, aspect: 1 },
  { file: "efpa.png", name: "EFPA – European Financial Planning Association", scale: 1.2, aspect: 2.68 },
];

// The row's label, in each language. The logos' names are their own.
const LABEL = { it: "Scelto da consulenti di", en: "Chosen by advisors from" };

// "Scelto da consulenti di": the institutions the advisors who use AVRAH
// come from, a still row under the label, on a band of its own across the
// page between the studio and the proof. It is the advisors who chose
// AVRAH, not their firms.
export default function TrustBanner() {
  // The row is far down the page: its logos wait until the page has settled
  // or the visitor nears it.
  const set = useRef(null);
  const ready = useDeferredLoad(set);
  const label = LABEL[useHomeLang()];
  return (
    <section aria-labelledby="hf-trust" className="hf-sec">
      <div className="tb">
        <div className="hf-wrap tb-in">
          <h2 id="hf-trust" className="tb-label">{label}</h2>
          <ul ref={set} className="tb-set" aria-labelledby="hf-trust">
            {LOGOS.map((logo) => (
              <li key={logo.file} className="tb-cell" style={{ "--scale": logo.scale, "--aspect": logo.aspect }}>
                <span className="tb-mark" role="img" aria-label={logo.name} style={ready ? { maskImage: `url(${LOGO_BASE}/${logo.file})` } : undefined} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
